import { Component, PropSync, Watch } from 'vue-property-decorator';
import SectionFieldsComponent from '@/components/edit/section/sectionfields/SectionFields';
import { ConfigurationField } from '@/models/configuration/Field';
import { FieldTypeEnum } from '@/enums/FieldTypeEnums';
import { ConfigurationSectionTypeEnum } from '@/enums/ConfigurationSectionTypeEnums';
import { ConfigurationService } from '@/services/index';
import { Configuration } from '@/models/configuration/Configuration';
import { ApiIdentifers } from '@/config/index';
import { LoggerService } from '@/utils/index';
import { IFieldEvent } from '@/components/edit/field/Field';

import FieldTable from '@/components/edit/fieldTable/FieldTable.vue';


@Component({
    components: {
        FieldTable,
    },
    name: 'SectionFieldsTableComponent',
})
export default class SectionFieldsTableComponent extends SectionFieldsComponent {
    @PropSync('sectionType') public syncedSectionType!: ConfigurationSectionTypeEnum;
    @PropSync('fieldType') public syncedFieldType!: FieldTypeEnum;

    public fieldTypes = FieldTypeEnum;
    public temperature = ApiIdentifers.unitTemperature;
    public climateTemperature = ApiIdentifers.climateTemperature;
    public tempertureUnit: string = '';

    public unitsConfiguration: Configuration = new Configuration();

    // tslint:disable-next-line: no-empty
    public mounted() {
        this.unitsConfiguration = this.getUnitsConfiguration;

        ConfigurationService.OnUsedTemperatureFormatChanged.on(() => {
            this.getUnitTemperature();
        });
    }

    public beforeDestroy() {
        ConfigurationService.OnUsedTemperatureFormatChanged.off(() => null);
    }

    get getUnitsConfiguration() {
        return ConfigurationService.GetUnitsConfiguration;
    }

    public onFieldEvent(event: IFieldEvent) {
        if (this.syncedFieldType === FieldTypeEnum.ACTION_SUBFIELD) {
            event.actionIndex = parseInt(this.syncedSectionRefName.split('__')[1] || '-1', 10);
        }
        this.fieldEvent(event);
    }

    public isNormalField(inField: ConfigurationField) {
        return (
            inField.identifier === ApiIdentifers.generalTemperatureFormat ||
            (inField.type !== FieldTypeEnum.SUBFIELD && inField.type !== FieldTypeEnum.UNIT && inField.type !== FieldTypeEnum.ACTION_SUBFIELD)
        );
    }

    public getUnitField(inField: ConfigurationField): ConfigurationField {
        const unitField = this.syncedFields.find((f) => f.identifier === inField.unit);
        if (unitField != null) {
            return unitField;
        } else {
            LoggerService.LogError(`unit field ${inField.unit} not found.`);
            return new ConfigurationField();
        }
    }

    public getUnitTemperature(): string {
        const unit = this.unitsConfiguration.sections.find((u) => u.identifier === ApiIdentifers.unitTemperature);
        if (unit != null && unit.values != null && ConfigurationService.GetUsedTemperatureFormat != null) {
            this.tempertureUnit = unit.values[ConfigurationService.GetUsedTemperatureFormat].text;
        } else {
            this.tempertureUnit = '';
            LoggerService.LogError(`getUnitTemperature could not find used format.`);
        }

        return this.tempertureUnit;
    }

    public isActionSubfield() {
        let isActionSubField = false;

        if (this.syncedSectionType != null) {
            if (this.syncedSectionType === ConfigurationSectionTypeEnum.ACTION) {
                isActionSubField = true;
            } else {
                isActionSubField = this.checkFieldTypes(this.syncedFields);
            }
        } else if (this.syncedFieldType != null) {
            isActionSubField = this.checkFieldTypes(this.syncedFields);
        }
        return isActionSubField;
    }

    /**
     * Method to fetch translation with fallback
     * @param inField ConfigurationField
     */
    public getIdentifierText(inField: ConfigurationField): string {
        let ret: string = '';
        ret = this.$vuetify.lang.t(`$vuetify.identifiers.${inField.identifier}`);
        // fallback to name string if no translation found
        console.log("Is Requried:",inField.required);            
        if (ret === undefined || ret.length === 0 || ret === inField.identifier || ret.includes('$vuetify.identifiers.')) {
            ret = inField.name;
            LoggerService.LogDebug(`getIdentifierText fallback text for: ${inField.identifier} --> ${ret}`);
        }
        if(inField.required) {
            ret = ret + '*'
        }
        return ret;
    }

    private checkFieldTypes(inFields: ConfigurationField[]): boolean {
        let isSubFieldOnly = true;
        for (const field of this.syncedFields || []) {
            if (field.type !== FieldTypeEnum.SUBFIELD) {
                isSubFieldOnly = false;
                break;
            }
        }
        return isSubFieldOnly;
    }
}
